/**
 * Modifies the image URL by replacing the internal portal IP with the API endpoint.
 * Ensures that URLs use HTTPS protocol.
 * 
 * @param {string} url - The original image URL.
 * @returns {string} The modified URL with the updated domain or the original URL if no changes are needed.
 */
export const modifyImageUrl = (url) => {
  if (typeof url === "string") {
    if (url.includes(process.env.PORTAL_INSIDE_IP)) {
      return changeDomainName(url, process.env.API_ENDPOINT);
    }
  }
  return url;
};

/**
 * Replaces the domain in the given URL with a new domain and ensures HTTPS is used.
 * 
 * @param {string} url - The original URL containing the old domain.
 * @param {string} newDomain - The new domain to replace the old one.
 * @returns {string} The updated URL with the new domain and HTTPS protocol.
 */
const changeDomainName = (url, newDomain) => {
  // Remove the protocol (http:// or https://) from newDomain if it exists
  const sanitizedDomain = newDomain.replace(/^https?:\/\//, "");

  // Replace the old domain with the new sanitized domain
  const modifiedUrl = url.replace(
    /\/\/([^/:]+)(:\d+)?/,
    (match, oldDomain, port) => `//${sanitizedDomain}`
  );

  // Ensure the URL uses HTTPS protocol
  return modifiedUrl.replace(/^http:/, "https:");
};